import { useEffect, useState } from 'react';
import { Form, Loader, TextArea } from 'semantic-ui-react';
import './AutoSaveTextArea.scss';

interface AutoSaveTextAreaProps {
    value:string
    onChange:(value:string, setIsLoading: React.Dispatch<React.SetStateAction<boolean>>)=>void
}

function AutoSaveTextArea({value, onChange}:AutoSaveTextAreaProps) {
    const [tempValue, setTempValue] = useState(value ?? '');
    const [isLoading, setIsLoading] = useState(false);
    useEffect(()=>{
        setTempValue(value);
    }, [value]);

    return <Form>
        <TextArea 
            value={tempValue} 
            onChange={(e) => {
                setTempValue(e.target.value)
            }}
            onBlur={() => onChange(tempValue, setIsLoading)} 
            />
        {isLoading && <Loader active size='tiny'/>}
    </Form>;
}
  
export default AutoSaveTextArea;
  